import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/studioInfoSagas";

export const CustomDateRange = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.studioInfo.rangeOptions);
  const selectedFilters = useSelector((state) => state.studioInfo.selectedRangeOption);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      includeFilter={false}
      placeholder="Select Date Range"
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};
